import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { first, map } from "rxjs/operators";

import { FileHandlerService } from "@shared/Services/fileHandler.service";

import { Insureds } from "@RGVSI/Shared/Types/Interfaces/customer.interface";

import { ClaimsRepository } from "../Repositories/claims.repository";
import { AssetCertificateDetail, associatedOrders, thirdParties, Vehicles } from "../Types/Interfaces/claims-detail.interface";
import { ClaimsFilter } from "../Types/Interfaces/claims-filter.interface";
import { Claims } from "../Types/Interfaces/claims.interface";
import { OptionType } from "../Types/Interfaces/option-type.interface";

@Injectable({
  providedIn: "root",
})
export class ClaimsService {
  constructor(private claimsRepository: ClaimsRepository, private fileHandlerService: FileHandlerService) {}

  public getClaims(claimsFilter: ClaimsFilter): Observable<Claims[]> {
    return this.claimsRepository.getClaims(claimsFilter);
  }

  public getStatus(): Observable<OptionType[]> {
    return this.claimsRepository.getStatus();
  }

  public getVehicleShops(): Observable<OptionType[]> {
    return this.claimsRepository.getVehicleShops();
  }

  public getClaimsVehicle(sinisterId: string): Observable<Vehicles[]> {
    return this.claimsRepository.getClaimsVehicle(sinisterId);
  }

  public getClaimsAssociatedOrders(sinisterId: string, inspectionNumber: string): Observable<associatedOrders[]> {
    return this.claimsRepository.getClaimsAssociatedOrders(sinisterId, inspectionNumber);
  }

  public getClaimsThirdParties(sinisterId: string, inspectionNumber: string): Observable<thirdParties[]> {
    return this.claimsRepository.getClaimsThirdParties(sinisterId, inspectionNumber);
  }

  public getClaimInsureds(sinisterId: string, contractorCustomerCode: string): Observable<Insureds[]> {
    return this.claimsRepository.getClaimsAffectedPersons(sinisterId, contractorCustomerCode).pipe(map((s) => s.insureds));
  }

  public getAssets(
    sinisterId: string,
    policyIdentification: string,
    certificateNumber: string
  ): Observable<AssetCertificateDetail[]> {
    return this.claimsRepository.getAssets(sinisterId, policyIdentification, certificateNumber);
  }

  public getClaimsReport(claimsFilter: ClaimsFilter): void {
    this.claimsRepository.getClaimsReport(claimsFilter).pipe(first()).subscribe(this.fileHandlerService.openPdfInNewTab);
  }
}
